import React from "react"

export function NavigationGroupItemLine() {
  return <span aria-hidden className="absolute left-5 -translate-x-1/2 inset-y-5 w-px bg-gray-300" />
}
